<template>

  <v-btn-toggle class="my-2" v-model="model" mandatory divided density="comfortable" variant="outlined" :disabled="!editable || busy">

    <v-tooltip v-if="!editable" activator="parent" text="Not editable for this user role" location="bottom" />
    
    <v-btn :value="UserSolutionControlValue.None" icon>
      <v-icon icon="$userSolutionsNone" />
      <v-tooltip activator="parent" :text="$t('enums.read_write_permissions.none')" location="bottom" />
    </v-btn>

    <v-btn v-if="!hideRead" :value="UserSolutionControlValue.Read" icon>
      <v-icon icon="$view" />
      <v-tooltip activator="parent" :text="$t('enums.read_write_permissions.read')" location="bottom" />
    </v-btn>

    <v-btn :value="UserSolutionControlValue.Write" icon>
      <v-icon icon="$edit" />
      <v-tooltip activator="parent" :text="$t('enums.read_write_permissions.write')" location="bottom" />
    </v-btn>

  </v-btn-toggle>

</template>

<script setup lang="ts">

import { UserSolutionControlValue } from './views/locations/types'

defineProps({

  editable: {
    type: Boolean,
    default: false,
  },

  busy: {
    type: Boolean,
    default: false,
  },

  hideRead: {
    type: Boolean,
    default: false,
  },

})

const model = defineModel<UserSolutionControlValue>()

</script>
